import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LINK_PATH } from '../../../constant';
import { useDropdownKeyboardNavigation } from '../../../components/Custom_Hooks/useDropdownKeyboardNavigation';
import NavigationList from '../../../components/NavigationList/NavigationList';
import useKeyboardNavigation from '../../../components/Custom_Hooks/useKeyboardNavigation';

const DisplayMoreReports = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const { userData = null } = useSelector((state) => state.auth);

    const hasPermission = React.useCallback((reportName) => {
        if (userData?.login_type === 'user' && Array.isArray(userData?.permissions)) {
            const pagePermissions = userData.permissions.find(p => (p.name?.toLowerCase() === reportName?.toLowerCase() || (reportName === 'Trial Balance' && p.name?.toLowerCase() === 'trail balance')) && p.category?.toLowerCase() === 'reports');
            return pagePermissions ? !!pagePermissions.view : false;
        }
        return true;
    }, [userData]);

    const keyMap = {
        't': hasPermission('Trial Balance') ? '/trial_balance' : '',
        'd': hasPermission('DayBook') ? (nav) => nav('/daybooktransaction', { state: { resetId: Date.now() } }) : '',
        'c': '/chartofaccountmasters',
        'f': '/voucherstransaction',
        'a': '/accountbook',
        's': '/statementofaccount',
        'i': '/inventorybook',
        'e': '/statementofinventory',
        'o': '/gstreport',
        'x': '/exceptionreports',
        'v': '/analysisverification',
    };

    useKeyboardNavigation(keyMap);

    const data = [
        // Accounting
        ...(hasPermission('Trial Balance') ? [{ category: "Accounting", to: '/trial_balance', text: 'Trial Balance' }] : []),
        ...(hasPermission('DayBook') ? [{ category: "Accounting", to: '/daybooktransaction', text: 'Day Book', state: { resetId: Date.now() } }] : []),
        { category: "Accounting", to: '/chartofaccountmasters', text: 'Cash Flow' },
        { category: "Accounting", to: '/chartofaccountmasters', text: 'Funds Flow' },
        { category: "Accounting", to: '/accountbook', text: 'Account Books' },
        { category: "Accounting", to: '/statementofaccount', text: 'Statements of Accounts' },
        // Inventory
        { category: "Inventory", to: '/inventorybook', text: 'Inventory Books' },
        { category: "Inventory", to: '/statementofinventory', text: 'Statements of Inventory' },
        // Statutory
        { category: "Statutory", to: '/gstreport', text: 'GST Reports' },
        // Exception
        { category: "Exception", to: `${LINK_PATH}/exceptionreports`, text: 'Exception Reports' },
        { category: "Exception", to: '/analysisverification', text: 'Analysis & Verification' }
    ];
    const { selectedItemIndex, setSelectedItemIndex } = useDropdownKeyboardNavigation({
        items: data,
        state: true,
        onItemSelect: (item) => {
            if (['/ledgerbook', '/current_date', '/period'].includes(location.pathname)) {
                return;
            }
            if (item.state) {
                navigate(item.to, { state: item.state })
            } else {
                navigate(item.to)
            }
        },

    });
    return (
        <NavigationList
            data={data}
            selectedItemIndex={selectedItemIndex}
            setSelectedItemIndex={setSelectedItemIndex}
            title='Display More Reports'
            first_heading='ACCOUNTING'
            secound_heading='INVENTORY'
            third_heading='EXCEPTION'
        />
    )
}

export default React.memo(DisplayMoreReports);
